import { ImageRetry } from '@openeducation/oe-rn-components';
import { ResizeMode } from 'expo-av';
import React from 'react';
import { StyleSheet } from 'react-native';

const TabActivityCardImage = ({ item, cardWidth }) => (
  <ImageRetry
    accessibilityIgnoresInvertColors
    source={{ uri: item.image }}
    style={[styles.image, { width: cardWidth, height: cardWidth * 0.625 }]}
  />
);

export default TabActivityCardImage;

const styles = StyleSheet.create({
  image: {
    resizeMode: ResizeMode.COVER,
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
  },
});
